import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "daqiaoweijiu:favorites";

function readFavorites(): string[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item): item is string => typeof item === "string");
  } catch {
    return [];
  }
}

export function useFavorites() {
  const [ids, setIds] = useState<string[]>([]);

  useEffect(() => {
    setIds(readFavorites());
  }, []);

  const toggle = useCallback((id: string) => {
    setIds((previous) => {
      const exists = previous.includes(id);
      const next = exists
        ? previous.filter((item) => item !== id)
        : [...previous, id];

      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {
        // 忽略本地存储不可用的场景
      }

      return next;
    });
  }, []);

  const isFavorite = useCallback(
    (id: string) => ids.includes(id),
    [ids],
  );

  return { ids, toggle, isFavorite };
}